// extracted by mini-css-extract-plugin
export default {"svg":"Icons_svg__ZkIrm","svgColor":"Icons_svgColor__62Fk8","strokeWidth":"Icons_strokeWidth__ffBsv","img":"Icons_img__m4PLy"};